export class SendCompanyWorkerMissingInfoEmailRequest {

    _id; // number,

    constructor(id) {
        this._id = id;
    }

    id() {
        return this._id;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/sendMissingInfoEmail/ws/SendCompanyWorkerMissingInfoEmailRequest.js